module.exports = __webpack_public_path__ + "static/media/liveroom_defult_banner0.09fee458.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/liveroom_defult_banner0.png
// module id = 1954
// module chunks = 6